import { compose } from 'redux';
import { connect } from 'react-redux';
import { withForm } from 'components/Form';
import { closeModal as closeModalAction } from 'components/Modal';
import { NETWORK_CAP_RECURRENCE, PERMISSION } from 'constants/logic';
import { selectUserHasPermission } from 'selectors/general';
import NetworkCapRecurrenceModal from './NetworkCapRecurrenceModal';

const mapStateToProps = (state, ownProps) => {
  const { networkCap, schedule } = ownProps;
  const { spots } = schedule;
  const { smartspotRecommendedSpots } = spots || {};
  const canManageClassSmartSpotOnOffNR = selectUserHasPermission(state, PERMISSION.CAN_SCHEDULE_SMARTSPOT_OFF_NR);

  return {
    ...ownProps,
    displayRecommendedSpots: !!(smartspotRecommendedSpots && networkCap < smartspotRecommendedSpots),
    canOnlyToggleNonRecurring: canManageClassSmartSpotOnOffNR,
    initialValues: {
      recurrence: NETWORK_CAP_RECURRENCE.THIS_INSTANCE,
    },
    schedule,
  };
};

const mapDispatchToProps = {
  closeModal: closeModalAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { closeModal, ...restDispatchProps } = dispatchProps;

  return {
    ...stateProps,
    ...restDispatchProps,
    onSubmit: ({ recurrence }) => closeModal(recurrence),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withForm({
    name: 'network-cap-recurrence-modal',
  })
)(NetworkCapRecurrenceModal);
